import React, { useState } from 'react';
import { AreaChart } from 'lucide-react';
import { InputGroup, InfoBox } from '../Common';

const EdgeTool = () => {
    const [rp, setRp] = useState(3);
    const [adr, setAdr] = useState(150);
    const cap = (rp / (adr || 1)) * 100;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Edge vs Market Range Analyzer</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Required Profit Pts" value={rp} onChange={setRp} />
                <InputGroup label="Avg Daily Range" value={adr} onChange={setAdr} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-amber">
                    <div className="tct-data-row"><span className="tct-label">Range Capture</span><span className="tct-value big-value val-amber">{cap.toFixed(2)}%</span></div>
                </div>
            </div>
            <InfoBox
                title="How Much of the Market Move Do You Really Need to Capture?"
                meta="Discover how little of the daily market movement traders actually need to capture to achieve consistent returns."
                sections={[
                    { title: "Introduction", content: "Many traders believe they need to capture large market moves to make money.<br><br>In reality, you only need a small percentage of daily range." },
                    { title: "Example", content: "Average NIFTY daily range = 150 points<br>Required profit = 3 points<br><br>Range capture = 3 / 150<br>Range capture = 2%<br><br>This means a trader only needs 2 percent of daily movement to achieve their goal." },
                    { title: "Why This Matters", content: "Understanding range capture helps traders:<br>• set realistic expectations<br>• reduce overtrading<br>• focus on consistency" },
                ]}
            />
        </div>
    );
};

export default EdgeTool;
